/**
 * Bellen zonder zaak (sessie 47, 9d).
 *
 * Een klik op Bel maakt geen zaak en geen tijdlijnregel meer. Vanuit
 * "Nieuw bericht" en de klantpagina is er dus geen tegel om het
 * belvenster in te openen; dit kleine paneel in de schil doet dat. Het
 * gesprek komt pas op een zaak als Rinkel het meldt.
 */
import { useSyncExternalStore } from "react";

export interface LosBellen {
  klantId: string | null;
  nummer: string | null;
  /** "nieuw_bericht" of "klantpagina". */
  bron: string;
}

let huidig: LosBellen | null = null;
const luisteraars = new Set<() => void>();

function meld(): void {
  for (const luisteraar of luisteraars) luisteraar();
}

export function openLosBellen(invoer: LosBellen): void {
  huidig = invoer;
  meld();
}

export function sluitLosBellen(): void {
  huidig = null;
  meld();
}

export function useLosBellen(): LosBellen | null {
  return useSyncExternalStore(
    (luisteraar) => {
      luisteraars.add(luisteraar);
      return () => luisteraars.delete(luisteraar);
    },
    () => huidig,
  );
}
